import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/financing")({
  head: () => pageHead({ title: 'RV Financing', description: 'Flexible RV financing options at Rex & Sons RVs. Get pre-approved for your next motorhome, travel trailer or fifth wheel.', path: '/financing' }),
  beforeLoad: () => {
    throw redirect({ href: "/rv-financing" });
  },
});
